import {css, useTheme} from '@mui/material';
import {DlMuiDynamicIcon, GetStylesFunction} from '@wallaby-ui/core';
import React, {CSSProperties} from 'react';

type Props = {
  label: string;
  value: boolean;
  onChange: (newValue: boolean) => void;
  style?: CSSProperties;
};
export const LightCheckbox: React.FC<Props> = (props) => {
  const {label, value, onChange, ...extraProps} = props;
  const theme = useTheme();
  const muiStyles = getStyles({theme});
  return (
    <span
      {...extraProps}
      css={muiStyles.checkboxWrapper}
      data-checked={value}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        onChange(!value);
      }}
    >
      <span>{label}</span>
      <DlMuiDynamicIcon
        iconName={value ? 'checkboxIconChecked' : 'checkboxIcon'}
        useFixedViewBox='0 0 12 12'
        style={{
          color: 'inherit',
          padding: 0,
          margin: 0,
          pointerEvents: 'none',
        }}
        noButtonStyles
      />
    </span>
  );
};
const getStyles: GetStylesFunction = (_options) => ({
  checkboxWrapper: css`
    padding-inline: 4px;
    cursor: pointer;
    display: inline-flex;
    gap: 4px;
    --labelOpacity: var(--lightCheckboxLabelOpacity, 0.285);
    color: var(--lightCheckbox, --dlTheme-500);
    &[data-checked='true'] {
      --labelOpacity: 1;
    }
    & span {
      opacity: var(--labelOpacity);
      font-size: 12px;
      cursor: pointer;
      user-select: none;
    }
    & svg {
      font-size: 14px;
      fill: none;
      /* a host may colour the circle apart from the label (the saved-filter row greys it like its icons) */
      color: var(--lightCheckboxIcon, inherit);
    }
    &[data-checked='false']:hover svg {
      color: var(--lightCheckboxIconHover, var(--lightCheckboxIcon, inherit));
    }
  `,
});
